<div class="header">
  <div class="search-section">
    <div class="menu-icon responsive-menu-icon" (click)="toggleSideMenu()" style="cursor: pointer;">
      <span class="material-symbols-outlined" id="hamburger_menu">
        menu
      </span>
    </div>
    <div class="search-div" tourAnchor="HeaderSearch" *ngIf="!hideGlobalSearch"
      [class.search-div--open]="isSearchDiv">
      <div class="search-field">
        <svg class="search-field-icon" width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path
            d="M15.0259 13.8478L18.5951 17.4162L17.4159 18.5953L13.8476 15.0262C12.5199 16.0905 10.8684 16.6694 9.16675 16.667C5.02675 16.667 1.66675 13.307 1.66675 9.16699C1.66675 5.02699 5.02675 1.66699 9.16675 1.66699C13.3067 1.66699 16.6667 5.02699 16.6667 9.16699C16.6692 10.8687 16.0903 12.5201 15.0259 13.8478ZM13.3542 13.2295C14.4118 12.1419 15.0025 10.684 15.0001 9.16699C15.0001 5.94366 12.3892 3.33366 9.16675 3.33366C5.94341 3.33366 3.33341 5.94366 3.33341 9.16699C3.33341 12.3895 5.94341 15.0003 9.16675 15.0003C10.6838 15.0027 12.1417 14.4121 13.2292 13.3545L13.3542 13.2295Z"
            fill="currentColor" />
        </svg>
        <input matInput #search
          (keyup)="onKey(search.value)"
          (keydown.escape)="closeSearch()"
          placeholder="Search pages, people, settings…"
          (click)="searchClick()"
          [attr.aria-expanded]="isSearchDiv"
          aria-autocomplete="list"
          autocomplete="off" />
      </div>

      <div class="searchbar-panel-div" *ngIf="isSearchDiv" role="listbox" (click)="$event.stopPropagation()">
        <p class="search-panel-hint search-panel-empty" *ngIf="searchQuery && !hasSearchResults">
          No matches for “{{ searchQuery }}”
        </p>

        <ng-container *ngFor="let section of searchData">
          <section class="search-group" *ngIf="sectionHasResults(section)">
            <h6 class="search-section-title">{{ section.section_type }}</h6>

            <ng-container *ngIf="section.section_type === 'Employee' && isEmployee">
              <button type="button" class="search-row" *ngFor="let data of section.data"
                (click)="userDetail(data.id)">
                <span class="search-row-mark" aria-hidden="true"></span>
                <span class="search-row-well">
                  <user-profile [user]="data" userImageClass="avatar-img" [sizeAvatar]="22"></user-profile>
                </span>
                <span class="search-row-text">
                  <span class="search-row-label">{{ data.name }}</span>
                </span>
              </button>
            </ng-container>

            <ng-container *ngIf="section.section_type === 'Teams' && isEmployee">
              <button type="button" class="search-row" *ngFor="let data of section.data"
                (click)="openTeamPage(data)">
                <span class="search-row-mark" aria-hidden="true"></span>
                <span class="search-row-well">
                  <ngx-avatars [name]="data.title.rendered" size="22"></ngx-avatars>
                </span>
                <span class="search-row-text">
                  <span class="search-row-label">{{ data.title.rendered }}</span>
                </span>
              </button>
            </ng-container>

            <ng-container *ngFor="let sectionItems of section.items">
              <button type="button" class="search-row"
                *ngIf="sectionItems.redirect && sectionItems.redirect !== '/teams'"
                [routerLink]="sectionItems.redirect"
                (click)="closeSearch()">
                <span class="search-row-mark" aria-hidden="true"></span>
                <span class="search-row-well">
                  <span class="material-symbols-outlined search-row-icon">{{ sectionItems.icon }}</span>
                </span>
                <span class="search-row-text">
                  <span class="search-row-label">{{ sectionItems.action_name }}</span>
                  <span class="search-row-sub" *ngIf="sectionItems.subtitle">{{ sectionItems.subtitle }}</span>
                </span>
              </button>

              <button type="button" class="search-row"
                *ngIf="sectionItems.redirect === '/teams'"
                (click)="openTeamsList()">
                <span class="search-row-mark" aria-hidden="true"></span>
                <span class="search-row-well">
                  <span class="material-symbols-outlined search-row-icon">{{ sectionItems.icon }}</span>
                </span>
                <span class="search-row-text">
                  <span class="search-row-label">{{ sectionItems.action_name }}</span>
                  <span class="search-row-sub" *ngIf="sectionItems.subtitle">{{ sectionItems.subtitle }}</span>
                </span>
              </button>

              <button type="button" class="search-row"
                *ngIf="sectionItems.action && sectionItems.action_type === 'team'"
                (click)="openModal(sectionItems.action_type)">
                <span class="search-row-mark" aria-hidden="true"></span>
                <span class="search-row-well">
                  <span class="material-symbols-outlined search-row-icon">{{ sectionItems.icon }}</span>
                </span>
                <span class="search-row-text">
                  <span class="search-row-label">{{ sectionItems.action_name }}</span>
                  <span class="search-row-sub" *ngIf="sectionItems.subtitle">{{ sectionItems.subtitle }}</span>
                </span>
              </button>

              <button type="button" class="search-row"
                *ngIf="sectionItems.action && sectionItems.action_type === 'employee' && canManageEmployees"
                (click)="openModal(sectionItems.action_type)">
                <span class="search-row-mark" aria-hidden="true"></span>
                <span class="search-row-well">
                  <span class="material-symbols-outlined search-row-icon">{{ sectionItems.icon }}</span>
                </span>
                <span class="search-row-text">
                  <span class="search-row-label">{{ sectionItems.action_name }}</span>
                  <span class="search-row-sub" *ngIf="sectionItems.subtitle">{{ sectionItems.subtitle }}</span>
                </span>
              </button>

              <button type="button" class="search-row"
                *ngIf="sectionItems.action && sectionItems.action_type === 'dashboard'"
                (click)="scrollToDashboardSection(sectionItems.target)">
                <span class="search-row-mark" aria-hidden="true"></span>
                <span class="search-row-well">
                  <span class="material-symbols-outlined search-row-icon">{{ sectionItems.icon }}</span>
                </span>
                <span class="search-row-text">
                  <span class="search-row-label">{{ sectionItems.action_name }}</span>
                  <span class="search-row-sub" *ngIf="sectionItems.subtitle">{{ sectionItems.subtitle }}</span>
                </span>
              </button>

              <button type="button" class="search-row"
                *ngIf="sectionItems.action && sectionItems.action_type === 'Settings'"
                (click)="openSettingsTab(sectionItems.target)">
                <span class="search-row-mark" aria-hidden="true"></span>
                <span class="search-row-well">
                  <span class="material-symbols-outlined search-row-icon">{{ sectionItems.icon }}</span>
                </span>
                <span class="search-row-text">
                  <span class="search-row-label">{{ sectionItems.action_name }}</span>
                  <span class="search-row-sub" *ngIf="sectionItems.subtitle">{{ sectionItems.subtitle }}</span>
                </span>
              </button>
            </ng-container>
          </section>
        </ng-container>
      </div>
    </div>
  </div>

  <div class="account-section">
    <!-- Compact Trial Badge -->
    <div class="trial-badge-compact" *ngIf="showTrialBadge && isAdmin"
      [ngClass]="{'trial-badge-expired': quotaStatus === 'expired' || quotaStatus === 'Expired' || quotaStatus === 'trial-expired' || quotaStatus === 'Trial-expired'}">
      <span class="trial-badge-text" *ngIf="quotaStatus === 'trial' || quotaStatus === 'Trial'">
        Trial expires in {{ daysRemaining }} Day{{ daysRemaining !== 1 ? 's' : '' }}
      </span>
      <span class="trial-badge-text" *ngIf="quotaStatus === 'active' || quotaStatus === 'Active'">
        Plan expires in {{ daysRemaining }} Day{{ daysRemaining !== 1 ? 's' : '' }}
      </span>
      <span class="trial-badge-text expired-text" *ngIf="quotaStatus === 'expired' || quotaStatus === 'Expired'">
        Plan Expired on {{dateOfExpiration}}
      </span>
      <span class="trial-badge-text expired-text"
        *ngIf="quotaStatus === 'trial-expired' || quotaStatus === 'Trial-expired'">
        Trial Expired on {{dateOfExpiration}}
      </span>
      <button class="trial-upgrade-btn" (click)="navigateToBilling()"
        *ngIf="quotaStatus === 'trial' || quotaStatus === 'Trial' || quotaStatus === 'trial-expired' || quotaStatus === 'Trial-expired'">Buy</button>
      <button class="trial-upgrade-btn" (click)="navigateToBilling()"
        *ngIf="quotaStatus === 'active' || quotaStatus === 'Active'">Renew</button>
      <button class="trial-renew-btn" (click)="navigateToBilling()"
        *ngIf="quotaStatus === 'expired' || quotaStatus === 'Expired'">Upgrade</button>
    </div>

    <button class="notification-bell" [class.notification-bell--pulse]="notificationBellPulse" mat-icon-button
      [matMenuTriggerFor]="notificationMenu" #notificationTrigger="matMenuTrigger" [matBadge]="screenshotBadgeLabel"
      [matBadgeHidden]="totalUnreadCount === 0" matBadgePosition="above after" matBadgeSize="small"
      matTooltip="Open recent team activity and status" matTooltipShowDelay="350" aria-label="Open recent activity"
      (menuOpened)="onNotificationsOpened()">
      <mat-icon aria-hidden="true">notifications</mat-icon>
    </button>

    <mat-menu #notificationMenu="matMenu" class="notification-menu-panel" xPosition="before" yPosition="below">
      <!-- Single wrapper div stops mat-menu from treating every child as a menu item -->
      <div class="nm-panel" (click)="$event.stopPropagation()">

        <!-- Header -->
        <div class="nm-header">
          <div class="nm-header-text">
            <span class="nm-title">Recent activity</span>
            <span class="nm-subtitle">Newest first · activity & status · top {{ screenshotPanelPeopleLimit }} people ·
              kept on this browser</span>
          </div>
          <span class="nm-badge" *ngIf="totalUnreadCount > 0"
            [attr.title]="'Events in queue (max ' + screenshotQueueMax + ')'">{{ screenshotBadgeLabel }}</span>
        </div>

        <div class="nm-list">
          <ng-container *ngIf="combinedActivity.length; else emptyState">
            <div class="nm-row" *ngFor="let item of combinedActivity" (click)="openEmployee(item.userId)" role="button"
              tabindex="0"
              [matTooltip]="item.activityType === 'screenshot' ? screenshotRowTooltip(item) : (item.userName + ' — ' + item.type + ' (' + item.relativeTime + ')')"
              matTooltipShowDelay="500" [attr.aria-label]="'Open profile for ' + item.userName"
              matTooltipTouchGestures="off" (keydown)="onNotificationRowKeydown($event, item.userId)">

              <div class="nm-avatar" [style.background]="item.color" aria-hidden="true">{{ item.initials }}</div>

              <div class="nm-body">
                <div class="nm-name-row">
                  <span class="nm-name" [title]="item.userName">{{ item.userName }}</span>
                  <span class="nm-time">{{ (item.triggerTime || item.receivedAt) | timeago:true }}</span>
                </div>

                <!-- Content Branching -->
                <div class="nm-sub-row">
                  <ng-container [ngSwitch]="item.activityType">
                    <!-- Screenshot Branch (Restored original logic/view) -->
                    <ng-container *ngSwitchCase="'screenshot'">
                      <span class="nm-pill">{{ item.count }} screenshot{{ item.count !== 1 ? 's' : '' }}</span>
                      <span class="nm-app" [title]="item.latestAppName"
                        *ngIf="item.latestAppName && item.latestAppName !== '—'">{{ item.latestAppName }}</span>
                      <span class="nm-captured" *ngIf="item.relativeTime">{{ item.relativeTime }}</span>
                    </ng-container>

                    <!-- Status Branch -->
                    <ng-container *ngSwitchCase="'status'">
                      <span class="nm-pill nm-pill--status capitalize" [ngClass]="item.type + '-status-chip'"
                        *ngIf="item.isStatusNotification">
                        {{ item.type }}
                      </span>
                      <span class="nm-pill nm-pill--status capitalize" *ngIf="!item.isStatusNotification">{{ item.type
                        }}</span>
                    </ng-container>
                  </ng-container>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-template #emptyState>
            <div class="nm-empty">
              <mat-icon class="nm-empty-icon" aria-hidden="true">notifications_active</mat-icon>
              <div class="nm-empty-title">You’re caught up</div>
              <div class="nm-empty-text">Screenshots and employee status changes will show here.</div>
            </div>
          </ng-template>
        </div>

        <!-- Footer -->
        <div class="nm-footer">
          <button type="button" class="nm-btn-link" (click)="navigateToScreenshots()">View all screenshots</button>
          <button type="button" class="nm-btn-clear" (click)="clearNotifications()"
            [disabled]="totalUnreadCount === 0">Clear all</button>
        </div>

      </div>
    </mat-menu>
    <div class="profile-section" tourAnchor="AdminProfile">
      <div class="avtar-contain">
        <div class="avatar-profile" (click)="
                isProfile = !isProfile;
                isSearchDiv = false;
                isNotification = false
              ">
          <ngx-avatars name="{{ getDisplayName() }}" size="36"></ngx-avatars>
          <!-- <div class="online-user"></div> -->
        </div>
      </div>
      <div class="company-name-container" style="margin: 0;">
        <h4 [title]="getDisplayName()" class="company-name-display">{{ getDisplayName() }}</h4>
        <p class="avtar-email">{{ adminData.user_email }}</p>
      </div>
      <div class="col s1 expand-icon" (click)="
              isProfile = !isProfile; isSearchDiv = false; isNotification = false
            ">
        <span class="material-symbols-outlined"> expand_more </span>
      </div>

      <div class="profilebar-div" *ngIf="isProfile">
        <div class="profile-line" [routerLink]="['/user-profile-info']" (click)="isProfile = false"
          style="cursor: pointer;">
          <div class="profile-avatar">
            <div class="avatar-profile">
              <ngx-avatars name="{{ getDisplayName() }}" size="36"></ngx-avatars>
            </div>
          </div>
          <div class="profile-name">
            <h5 class="admin-name" [title]="getDisplayName()">{{ getDisplayName() }}</h5>
            <h6>{{adminData.role.length ? adminData.role[0] == 'employee' ? adminData.role[1] : adminData.role[0] ==
              'company' ? 'admin' : adminData.role[0] : ''}}</h6>
          </div>
        </div>
        <div class="row dropdown-hover" style="border-bottom: 1px solid #80808021;" (click)="resumeSetupFromHeader()"
          *ngIf="isAdmin && !isPaid && !showJourneyMenuItem && !trialOnboardingHelp.isOnboardingCompleted()">
          <div class="col s12">
            <p><span class="material-symbols-outlined">rocket_launch</span> <span style="font-size: 16px;">Resume
                setup</span>
            </p>
          </div>
        </div>
        <!-- <div class="row dropdown-hover" style="border-bottom: 1px solid #80808021;" (click)="startTour()"
          *ngIf="showTakeTourOption">
          <div class="col s12">
            <p><span class="material-symbols-outlined"> tour </span> <span style="font-size: 16px;">Take tour</span>
            </p>
          </div>
        </div> -->
        <div class="row dropdown-hover" style="border-bottom: 1px solid #80808021;" (click)="tryDemoDataFromHeader()"
          *ngIf="isAdmin && !isPaid && trialOnboardingHelp.canShowOptionalHelpLinks()">
          <div class="col s12">
            <p><span class="material-symbols-outlined">dataset</span> <span style="font-size: 16px;">{{ trialOnboardingHelp.isShowingDemoData()
                ? 'Hide' : 'Try'}} sample data</span>
            </p>
          </div>
        </div>
        <div class="row dropdown-hover" style="border-bottom: 1px solid #80808021;" (click)="moveToBillingInvoices()"
          *ngIf="isAdmin">
          <div class="col s12">
            <p><span class="material-symbols-outlined"> receipt_long </span> <span style="font-size: 16px;">Billing &amp; Invoices</span>
            </p>
          </div>
        </div>
        <div class="row dropdown-hover" style="border-bottom: 1px solid #80808021;" (click)="openJourneyFromHeader()"
          *ngIf="showJourneyMenuItem">
          <div class="col s12">
            <p><span class="material-symbols-outlined">route</span> <span style="font-size: 16px;">Journey</span>
            </p>
          </div>
        </div>
        <div class="row dropdown-hover" style="border-bottom: none" (click)="logoutCall()">
          <div class="col s12">
            <p><span class="material-symbols-outlined"> logout </span> <span style="font-size: 16px;">Logout</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
